// Shared test IDs for sub pages
export const SID = {
  // Solution pages
  solutionHeroBookDemo: "solution-hero-book-demo",
  solutionHeroSeePricing: "solution-hero-see-pricing",
  solutionFaq: (i) => `solution-faq-item-${i}`,
  solutionFeatureCard: (k) => `solution-feature-${k}`,

  // Features page
  featuresHeroCta: "features-hero-cta",
  featureCategory: (k) => `feature-category-${k}`,
  featureItem: (k) => `feature-item-${k}`,

  // Pricing page
  pricingTabMonthly: "pricing-tab-monthly",
  pricingTabAnnual: "pricing-tab-annual",
  pricingPlan: (k) => `pricing-plan-${k}`,
  pricingCta: (k) => `pricing-cta-${k}`,
  pricingFaq: (i) => `pricing-faq-${i}`,

  // Contact page
  contactName: "contact-name",
  contactEmail: "contact-email",
  contactPhone: "contact-phone",
  contactCompany: "contact-company",
  contactInterest: "contact-interest",
  contactMessage: "contact-message",
  contactSubmit: "contact-submit",
  contactSuccess: "contact-success",

  // About page
  aboutValue: (i) => `about-value-${i}`,

  // 404
  notFoundHome: "notfound-go-home",
};
